/* eslint-disable import/no-default-export */
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/controller-factory/controllerFactory';
import {Experiments} from '../../constants';
import {ConditionalController} from '@wix/wixstores-client-storefront-common';
import {GalleryController} from '../../viewerScript/GalleryController';
import {OldGalleryController} from '../../viewerScript/OldGalleryController';

export default ConditionalController(
  Experiments.RemoveControllerFactory,
  GalleryController(),
  controllerFactory(OldGalleryController, {shouldSkipMultilingual: true})
);
